{
    "InsightsDashboard_Title": "Einblicke",
    "InsightsDashboard_BusinessFilter": "Business Filter",
    "InsightsDashboard_AllPartitions": "Alle Seiten",
    "InsightsDashboard_CallsReceived": "Empfangene Anrufe",
    "InsightsDashboard_MissedCalls": "Verpasste Anrufe",
    "InsightsDashboard_AverageAnswer": "Durchschnittliche Antwort",
    "InsightsDashboard_AverageAbandoned": "Durchschnittlich aufgegeben",
    "InsightsDashboard_LongestWait": "Längste Wartezeit",
    "InsightsDashboard_VsLastWeekCurrently": "Momentan",
    "InsightsDashboard_PercentVsLastWeek": "**{}%** im Vergleich zur letzten Woche",
    "InsightsDashboard_VsLastWeek": "**{}** vs. letzte Woche",
    "InsightsDashboard_BusiestDay": "Arbeitsreichster Tag",
    "InsightsDashboard_PeakCalls": "Anrufspitzen",
    "InsightsDashboard_MostCalledInboundNumber": "Am häufigsten angerufene Inbound-Nummer",
    "InsightsDashboard_MostAnsweredCalls": "Meistbeantwortete Anrufe",
    "InsightDashboard_CalledNumber": "Angerufene Nummer",
    "InsightsDashboard_User": "Benutzer",
    "InsightsDashboard_SecondsDisplay": "{}S",
    "InsightsDashboard_Tooltip_TimeLabel": "Zeit: {}:00",
    "InsightsDashboard_Tooltip_DayLabel": "Tag: {}",
    "InsightsDashboard_Tooltip_CallsLabel": "Anzahl der Anrufe: {}",
    "InsightsDashboard_Tooltip_Stats_0": "Empfangene Anrufe: {}",
    "InsightsDashboard_Tooltip_Stats_1": "Verpasste Anrufe: {}",
    "InsightsDashboard_Tooltip_Stats_2": "Durchschnittlich beantwortet: {}",
    "InsightsDashboard_Tooltip_Stats_3": "Durchschnittlich aufgegeben: {}",
    "InsightsDashboard_Tooltip_Stats_4": "Längste Wartezeit: {}",
    "InsightsDashboard_Tooltip_Stats_WeekCommencing": "Woche beginnt: {}",
    "InsightsDashboard_OfLast30Days": "der letzten 30 Tage",
    "InsightsDashboard_OverLast30Days": "In den letzten 30 Tagen",
    "InsightsDashboard_OverLast7Days": "In den letzten 7 Tagen",
    "InsightsDashboard_ThisWeek": "Diese Woche",
    "InsightsDashboard_LastWeek": "Letzte Woche",
    "InsightsDashboard_PrevWeek": "Vorherige Woche",
    "InsightsDashboard_ErrorState_Message": "Es tut uns leid, es ist ein Problem aufgetreten. \n Bitte aktualisieren Sie Ihren Browser. \n \n {}",
    "InsightsDashboard_ErrorState_No_TelSys_Or_Partition": "Kein Telefonieserver oder keine Partition ausgewählt",
    "InsightsDashboard_Tour_Step_1": "Hier wählen Sie Ihr Unternehmen und Ihren Standort aus",
    "InsightsDashboard_Tour_Step_2": "Sehen Sie sich die Touchpoint-Kennzahlen Ihres Unternehmens der letzten 30 Tage an: \n ##?##Arbeitsreichste Tage, damit Sie Ressourcen besser planen können####Arbeitsreichste Zeiten, seien Sie in Spitzenzeiten mit einer Vertretung bereit, um keine Anrufe zu verpassen####?",
    "InsightsDashboard_Tour_Step_3": "Wichtige Kennzahlen zur Anrufleistung der letzten 30 Tage: \n ##?##Gesamtzahl der von Ihrem Unternehmen empfangenen Anrufe####Verpasste Anrufe####Durchschnittliche Antwort- und Abbruchzeiten####Längste Wartezeit eines Anrufs####? \n Klicken Sie auf die Kennzahlen, um einen wöchentlichen Vergleich und Trends anzuzeigen.",
    "InsightsDashboard_Tour_Step_4": "Ermitteln Sie Ihre am häufigsten gewählten eingehenden Durchwahlnummern der letzten 7 Tage und welche Benutzer die meisten Anrufe entgegennehmen. Die Top 10 werden angezeigt.",
    "InsightsDashboard_Tour_Step_5": "Klicken Sie hier, um das Meldeportal zu öffnen",
    "InsightsDashboard_Tour_Step_6": "Klicken Sie hier, um das Meldeportal zu öffnen",
    "NAME": "InsightsDashboardLanguage"
}